import { BuildClass } from '../../../universal';
import { React } from '../../lib';
export const LoadingSpinnerSmall = () => (React.createElement("img", { className: "inline loading-spinner loading-spinner-new", src: "/static/img/svg/ajax-small.svg", title: "Loading..." }));
const classCircle = BuildClass([
    'absolute bg-transparent animate-spin',
    'border-3 border-transparent rounded-full',
]);
export const LoadingSpinnerLarge = () => (React.createElement("div", { className: "tailwind-wrapper", style: {
        background: 'transparent',
        width: '160px',
        height: '160px',
        position: 'relative',
        top: 'calc(33% - 80px)',
        left: 'calc(50% - 80px)',
    } },
    React.createElement("div", { className: BuildClass([
            classCircle,
            'w-[160px] h-[160px]',
            'top-[calc((100%-160px)/3)] left-[calc((100%-160px)/2)]',
            'border-t-[#3498db]',
            '[animation-duration:_1.5s]',
        ]) }),
    React.createElement("div", { className: BuildClass([
            classCircle,
            'w-[140px] h-[140px]',
            'top-[calc((100%-140px)/3+3px)] left-[calc((100%-140px)/2-0px)]',
            'border-t-[#e74c3c]',
            '[animation-duration:_1.5s]',
            '[animation-direction:_reverse]',
        ]) }),
    React.createElement("div", { className: BuildClass([
            classCircle,
            'w-[120px] h-[120px]',
            'top-[calc((100%-120px)/3+6px)] left-[calc((100%-120px)/2-0px)]',
            'border-t-[#f9c922]',
            '[animation-duration:_1s]',
        ]) }),
    React.createElement("div", { className: BuildClass([
            classCircle,
            'w-[100px] h-[100px]',
            'top-[calc((100%-100px)/3+9px)] left-[calc((100%-100px)/2-0px)]',
            'border-t-[#3c3]',
            '[animation-duration:_1s]',
            '[animation-direction:_reverse]',
        ]) })));
//# sourceMappingURL=loading.js.map